import Dashboard from "../../components/Dashboard/Dashboard";
import React from "react";
import {Mail, Message, People, Settings, ViewList} from "@material-ui/icons";
import UserList from "../../components/UserList/UserList";
import {Container, Typography} from "@material-ui/core";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            backgroundColor: theme.palette.background.paper,
            padding: '0 0'
        },
    }),
)

const AdminBoard = () => {
    const menu = [
        {title: 'Users', icon: <People/>, link: '/users'},
        {title: 'Posts', icon: <ViewList/>, link: '/posts'},
        {title: 'Send message', icon: <Message/>, link: '/sendmsg'},
        {title: 'Mailing', icon: <Mail/>, link: '/mailing'},
        {title: 'Settings', icon: <Settings/>, link: '/settings'},
    ]

    const classes = useStyles();


    return (
        <div>
            <Dashboard menu={menu}>
                <Container maxWidth="xl" className={classes.root}>
                    <Typography variant={'h4'}>
                        Users
                    </Typography>
                    <UserList/>
                </Container>
            </Dashboard>
        </div>
    );
};

export default AdminBoard;
